export default __webpack_public_path__ + "static/media/ssfastners.dbc6add91358b56af5af.711488a3.webp";